import { Route } from "components/Route";
import { Switch } from "react-router-dom";
import { routes } from "routes";
import { AddStudentEvaluationLoading } from "./AddStudentEvaluationPage";
import { GroupResultPage } from "./GroupResultPage";
import { GroupTablePage } from "./GroupTablePage";
import {
	DefaultGroupLoadingPage,
	StudentResultLoadingPage,
} from "./ResultPage";
import { StudentTablePage } from "./StudentTablePage";

export const ResultSwitch = (): JSX.Element => (
	<Switch>
		<Route exact path={[routes._.result.path]}>
			<DefaultGroupLoadingPage />
		</Route>

		<Route exact path={[routes._.result._.Groups.path]}>
			<GroupTablePage />
		</Route>

		<Route exact path={[routes._.result._.Groups._.viewGroupResult.path]}>
			<GroupResultPage />
		</Route>

		<Route
			exact
			path={[
				routes._.result._.Students.path,
				routes._.result._.Groups._.viewGroup.path,
			]}
		>
			<StudentTablePage />
		</Route>

		<Route exact path={routes._.result._.viewResult.path}>
			<StudentResultLoadingPage />
		</Route>
		<Route exact path={routes._.result._.addEvaluation.path}>
			<AddStudentEvaluationLoading />
		</Route>
	</Switch>
);

export const StudentResultSwitch = (): JSX.Element => {
	return (
		<Switch>
			{/* <Route exact path={[routes._.result._.viewResult.path]}>
				<ParentResultPage />
			</Route> */}
			<Route exact path={[routes._.result.path]}>
				<StudentResultLoadingPage />
			</Route>
		</Switch>
	);
};
